// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts"
// @generated from file logins.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AuthTokenValidityRequest, LogoutRequest, LogoutResponse, UserLoginRequest, UserLoginResponse } from "./logins_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { BooleanResponse } from "./base_pb.js";

/**
 *
 * Describes the methods applicable on the login service
 *
 * @generated from service nail2poll.LoginService
 */
export const LoginService = {
  typeName: "nail2poll.LoginService",
  methods: {
    /**
     * Login using credentials belonging to a user
     *
     * @generated from rpc nail2poll.LoginService.UserLogin
     */
    userLogin: {
      name: "UserLogin",
      I: UserLoginRequest,
      O: UserLoginResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Check if the auth token is still valid
     *
     * @generated from rpc nail2poll.LoginService.IsAuthTokenValid
     */
    isAuthTokenValid: {
      name: "IsAuthTokenValid",
      I: AuthTokenValidityRequest,
      O: BooleanResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Logout
     *
     * @generated from rpc nail2poll.LoginService.Logout
     */
    logout: {
      name: "Logout",
      I: LogoutRequest,
      O: LogoutResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

